import requests from './httpService';

const ChunkedUploadService = {
  // Initialize chunk upload session
  initializeChunkUpload(body) {
    return requests.post(`/chunkedupload/initialize`, body);
  },

  // Upload a single chunk
  uploadChunk(formData) {
    // Don't set Content-Type header - browser will set it automatically with boundary for FormData
    return requests.post(`/chunkedupload/chunk`, formData);
  },

  // Complete chunk upload and commit all blocks
  completeChunkUpload(body) {
    return requests.post(`/chunkedupload/complete`, body);
  },

  // Get upload progress
  getUploadProgress(uploadId) {
    return requests.get(`/chunkedupload/progress/${uploadId}`);
  },

  // Delete uploaded file by blobName
  deleteUploadedFile(blobName) {
    return requests.delete(`/chunkedupload/file`, { blobName });
  },

  // Cancel/Delete incomplete upload session
  cancelUploadSession(uploadId) {
    return requests.post(`/chunkedupload/cancel`, { uploadId });
  },

  // Delete file by URL
  deleteFileByUrl(fileUrl) {
    return requests.delete(`/chunkedupload/file/url`, { fileUrl });
  },
};

export default ChunkedUploadService;

